import React, { useState, useEffect } from 'react';
import './index.scss';

const LoadingComponent = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        const nextProgress = prevProgress + Math.random() * 8;
        return nextProgress >= 100 ? 100 : nextProgress;
      });
    }, 150);

    return () => clearInterval(interval);
  }, []);

  const circumference = 2 * Math.PI * 46;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="fukkoni-loading-container">
      <div className="loading-logo-wrapper">
        <div className="logo-center">
          <svg
            width="64"
            height="64"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fukkoni-logo"
          >
            <title>FUKKONI Super App Icon</title>
            <desc>
              Icon representing a central platform managing multiple business
              types for FUKKONI.
            </desc>
            <defs>
              <linearGradient
                id="greenGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#10B981" />
                <stop offset="100%" stopColor="#34D399" />
              </linearGradient>
            </defs>
            <rect width="100" height="100" rx="20" fill="url(#greenGradient)" />
            <circle cx="50" cy="50" r="15" fill="#ffffff" />
            <circle cx="30" cy="25" r="8" fill="#ffffff" />
            <circle cx="70" cy="25" r="8" fill="#ffffff" />
            <circle cx="20" cy="50" r="8" fill="#ffffff" />
            <circle cx="80" cy="50" r="8" fill="#ffffff" />
            <circle cx="30" cy="75" r="8" fill="#ffffff" />
            <circle cx="70" cy="75" r="8" fill="#ffffff" />
            <line
              x1="50"
              y1="50"
              x2="30"
              y2="25"
              stroke="#ffffff"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <line
              x1="50"
              y1="50"
              x2="70"
              y2="25"
              stroke="#ffffff"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <line
              x1="50"
              y1="50"
              x2="20"
              y2="50"
              stroke="#ffffff"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <line
              x1="50"
              y1="50"
              x2="80"
              y2="50"
              stroke="#ffffff"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <line
              x1="50"
              y1="50"
              x2="30"
              y2="75"
              stroke="#ffffff"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <line
              x1="50"
              y1="50"
              x2="70"
              y2="75"
              stroke="#ffffff"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <svg className="progress-circle" viewBox="0 0 100 100">
          <circle
            cx="50"
            cy="50"
            r="46"
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="6"
            className="circle-bg"
          />

          <circle
            cx="50"
            cy="50"
            r="46"
            fill="none"
            stroke="#10B981"
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            transform="rotate(-90 50 50)"
            className="circle-progress"
          />
        </svg>
      </div>

      {/* Loading text */}
      <div className="loading-text">
        <h2 className="loading-title">
          <span>FUKKONI</span>
          <span className="loading-status">
            {progress < 100 ? 'Loading...' : 'Ready!'}
          </span>
        </h2>

        <div className="loading-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>

        <p className="loading-progress">{Math.round(progress)}% complete</p>
      </div>
    </div>
  );
};

export default LoadingComponent;
